import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Dropdown from '../Dropdown/Dropdown'
import FilterOptionsDropdown from '../Dropdown/FilterOptionsDropdown'
import Board from '../Board/Board'
import Task from '../Task/Task'
import AddTask from '../Task/AddTask'
import FilterOptions from '../FilterOptions/FilterOptions'
import SlackPopup from '../Slack/SlackPopup'
import ContextSearch from './ContextSearch'
import { fetchAllTasks, fetchAssigneeList } from '../../Api/tasks'
import { fetchTagsList } from '../../Api/tags'
import { fetchSlackUsersAndChannels } from '../../Api/slack'
import './tasks.css'

const Tasks = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const [tasksData, setTasksData] = useState([])
  const [selectedTagFilters, setSelectedTagFilters] = useState([''])
  const [selectedSortedByFilter, setSelectedSortedByFilter] = useState(
    'due date'
  )
  const [channelsAndUsers, setChannelsAndUsers] = useState([])

  const [selectedFilterOptions, setSelectedFilterOptions] = useState([])
  const [
    showSelectedFilterOptionValues,
    setShowSelectedFilterOptionValues,
  ] = useState(null)
  const [
    showSelectedFilterOptionNature,
    setShowSelectedFilterOptionNature,
  ] = useState(null)

  const [selectedFilter, setSelectedFilter] = useState('')
  const [
    selectedCategorizedByFilter,
    setSelectedCategorizedByFilter,
  ] = useState('status')
  const tagFilterButtonRef = useRef(null)
  const sortedByButtonRef = useRef(null)
  const categorizedByButtonRef = useRef(null)
  const [assignees, setAssignees] = useState([])
  const [tags, setTags] = useState([])
  const tage = tags.map(({ label }) => label)
  const [hideFilters, setHideFilters] = useState(false)
  const [slackShareData, setSlackShareData] = useState(null)

  const sortedBy = [
    {
      value: 'due date',
      label: 'due date',
    },
  ]

  const categorizedBy = [
    {
      value: 'status',
      label: 'status',
    },
  ]

  const filters = [
    {
      value: 'Assignee',
      label: 'Assignee',
    },
    {
      value: 'Due Date',
      label: 'Due Date',
    },
    {
      value: 'Nature',
      label: 'Nature',
    },
    {
      value: 'Priority',
      label: 'Priority',
    },
  ]

  const duedate = [
    {
      value: 'Overdue',
      label: 'Overdue',
    },
    {
      value: 'Due in next week',
      label: 'Due in next week',
    },
    {
      value: 'Due in next 2 days',
      label: 'Due in next 2 days',
    },
    {
      value: 'Not due',
      label: 'Not due',
    },
  ]

  const nature = [
    {
      value: 'Shared',
      label: 'Shared',
    },
    {
      value: 'Private',
      label: 'Private',
    },
  ]
  const priority = [
    {
      value: '0_HIGH',
      label: 'HIGH',
    },
    {
      value: '1_MEDIUM',
      label: 'MEDIUM',
    },
    {
      value: '2_LOW',
      label: 'LOW',
    },
  ]

  const fetchUsersAndChannelsHandler = useCallback(async () => {
    const apiResponse = await fetchSlackUsersAndChannels()
    if (apiResponse?.slackUsersAndChannels.length > 0) {
      setChannelsAndUsers([
        ...apiResponse.slackUsersAndChannels.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      ])
    } else {
      setChannelsAndUsers([])
    }
  }, [setChannelsAndUsers])
  useEffect(() => {
    fetchUsersAndChannelsHandler()
  }, [fetchUsersAndChannelsHandler])

  const fetchTasksData = useCallback(async () => {
    const apiResponse = await fetchAllTasks(searchParams.get('tag'))
    if (apiResponse) {
      if (apiResponse.length > 0) {
        let openIndex = apiResponse.filter((item) => item.status === 'OPEN')
        let inProgressIndex = apiResponse.filter(
          (item) => item.status === 'IN_PROGRESS'
        )
        let doneIndex = apiResponse.filter((item) => item.status === 'DONE')
        if (openIndex?.length !== 1) {
          openIndex = [
            {
              status: 'OPEN',
              docs: [],
            },
          ]
        }
        if (inProgressIndex?.length !== 1) {
          inProgressIndex = [
            {
              status: 'IN_PROGRESS',
              docs: [],
            },
          ]
        }

        if (doneIndex?.length !== 1) {
          doneIndex = [
            {
              status: 'DONE',
              docs: [],
            },
          ]
        }
        openIndex[0].overdue = (
          ((openIndex[0]?.docs?.filter(
            (item) => new Date(item.dueDate).getTime() <= new Date().getTime()
          )?.length || 0) /
            openIndex[0].docs.length) *
          100
        ).toFixed(2)

        inProgressIndex[0].overdue = (
          ((inProgressIndex[0]?.docs?.filter(
            (item) => new Date(item.dueDate).getTime() <= new Date().getTime()
          )?.length || 0) /
            inProgressIndex[0].docs.length) *
          100
        ).toFixed(2)
        setTasksData([...openIndex, ...inProgressIndex, ...doneIndex])
      } else {
        setTasksData([])
      }
    } else {
      setTasksData([])
    }
  }, [searchParams])

  const fetchAssigneesData = useCallback(async () => {
    const apiResponse = await fetchAssigneeList()
    if (apiResponse) {
      setAssignees([
        ...apiResponse.map((item) => ({
          value: item.email,
          label: item.fullName ? item.fullName : item.email,
        })),
      ])
    } else {
      setAssignees([])
    }
  }, [])

  const fetchTagsData = useCallback(async () => {
    const apiResponse = await fetchTagsList()
    if (apiResponse) {
      setTags([
        ...apiResponse.map((item) => ({
          value: item._id,
          label: item.name,
        })),
      ])
    } else {
      setTags([])
    }
  }, [])

  useEffect(() => {
    fetchTasksData()
    fetchAssigneesData()
    fetchTagsData()
  }, [fetchTagsData, fetchTasksData, fetchAssigneesData, searchParams])

  useEffect(() => {
    if (searchParams.get('tag') && searchParams.get('tag') !== 'null') {
      setSelectedTagFilters(searchParams.get('tag').split(','))
    } else {
      setSelectedTagFilters([''])
    }
  }, [searchParams, setSelectedTagFilters])

  const showFilterOptionDropdownHandler = useCallback((isNature, index) => {
    if (isNature) {
      setShowSelectedFilterOptionNature(index)
      setShowSelectedFilterOptionValues(null)
    } else {
      setShowSelectedFilterOptionNature(null)
      setShowSelectedFilterOptionValues(index)
    }
  }, [])

  const filterOptionChangeHandler = useCallback(
    (isNature, index, value) => {
      const temp = [...selectedFilterOptions]
      if (isNature) {
        temp[index].nature = value
      } else {
        if (value.length > 0) {
          temp[index].value = value
        } else {
          temp.splice(index, 1)
        }
      }
      setSelectedFilterOptions([...temp])
      if (isNature) {
        setShowSelectedFilterOptionNature(null)
      }
    },
    [selectedFilterOptions]
  )

  const removeFilterOptionHandler = useCallback(
    (index) => {
      const temp = [...selectedFilterOptions]
      temp.splice(index, 1)
      setSelectedFilterOptions([...temp])
    },
    [selectedFilterOptions]
  )

  const removeTagFilters = useCallback(
    (index) => {
      const temp = [...selectedTagFilters]
      temp.splice(index, 1)
      navigate(
        `/tasks/?tag=${temp.join(',')}&task=${searchParams.get(
          'task'
        )}&card=${searchParams.get('card')}`
      )
    },
    [selectedTagFilters, navigate, searchParams]
  )

  return (
    <div className='container'>
      <ContextSearch />
      <div
        className={
          searchParams.get('task') || searchParams.get('card')
            ? 'tasks active'
            : 'tasks'
        }
      >
        <section className='header'>
          <div>
            <h1>Tasks</h1>
            <p>(Notes & more coming soon! 🔥)</p>
          </div>
          {/* <button>
          <span>+</span>Add to meeting discussion
        </button> */}
        </section>
        {!hideFilters && (
          <>
            <section className='tags'>
              {selectedTagFilters.indexOf('') === -1 && (
                <div className='header'>
                  <h3>Tags</h3>
                  <button
                    onClick={() =>
                      navigate(
                        `/tasks/?tag=&task=${searchParams.get(
                          'task'
                        )}&card=${searchParams.get('card')}`
                      )
                    }
                  >
                    Clear all
                  </button>
                </div>
              )}
              <div className='body'>
                <div className='filter'>
                  <button
                    className='tag-filter-button'
                    ref={tagFilterButtonRef}
                  >
                    <span>+</span>Add tag
                  </button>
                  <Dropdown
                    isSearchable={true}
                    isMultiple={true}
                    data={tags}
                    setActiveFilters={setSelectedTagFilters}
                    activeFilters={selectedTagFilters}
                    ref={tagFilterButtonRef}
                    resetFilters={setSelectedFilter}
                    filterName='tag'
                  />
                </div>
                {selectedTagFilters &&
                  selectedTagFilters.length > 0 &&
                  selectedTagFilters.indexOf('') === -1 && (
                  <ul>
                    {selectedTagFilters.map((tag, index) => (
                      <li key={tag}>
                        <span>
                          {
                            tags?.filter(
                              (item) =>
                                item.value !== '' && item.value === tag
                            )[0]?.label
                          }
                        </span>
                        <button onClick={() => removeTagFilters(index)}>
                            x
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </section>
            <section className='sort-catergorize'>
              <div className='filter'>
                <button className='tag-filter-button' ref={sortedByButtonRef}>
                  <span>Sorted By</span>
                  {selectedSortedByFilter}
                </button>
                <Dropdown
                  isMultiple={false}
                  data={sortedBy}
                  setActiveFilters={setSelectedSortedByFilter}
                  activeFilters={selectedSortedByFilter}
                  ref={sortedByButtonRef}
                  resetFilters={setSelectedFilter}
                />
              </div>
              <div className='filter'>
                <button
                  className='tag-filter-button'
                  ref={categorizedByButtonRef}
                >
                  <span>Categorized By</span>
                  {selectedCategorizedByFilter}
                </button>
                <Dropdown
                  isMultiple={false}
                  data={categorizedBy}
                  setActiveFilters={setSelectedCategorizedByFilter}
                  activeFilters={selectedCategorizedByFilter}
                  ref={categorizedByButtonRef}
                  resetFilters={setSelectedFilter}
                />
              </div>
            </section>
          </>
        )}
        <section className='filters'>
          <FilterOptionsDropdown
            data={
              selectedFilter === 'Assignee'
                ? assignees
                : selectedFilter === 'Due Date'
                  ? duedate
                  : selectedFilter === 'Priority'
                    ? priority
                    : selectedFilter === 'Nature'
                      ? nature
                      : []
            }
            isSearchable={selectedFilter === 'Assignee' ? true : false}
            selectedFilter={selectedFilter}
            filter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            setSelectedFilterOptions={setSelectedFilterOptions}
            activeFilters={selectedFilterOptions}
            selectedFilterOptions={selectedFilterOptions}
            filters={filters}
            hideFilters={hideFilters}
            setHideFilters={setHideFilters}
          />
          {!hideFilters &&
            selectedFilterOptions &&
            selectedFilterOptions.length > 0 && (
            <ul className='selected-filters'>
              {selectedFilterOptions.map((filterOption, index) => (
                <FilterOptions
                  filterOption={filterOption}
                  assignees={assignees}
                  duedate={duedate}
                  priority={priority}
                  nature={nature}
                  key={filterOption.filter + index}
                  removeFilterOptionHandler={removeFilterOptionHandler}
                  filterOptionChangeHandler={filterOptionChangeHandler}
                  showFilterOptionDropdownHandler={
                    showFilterOptionDropdownHandler
                  }
                  showSelectedFilterOptionValues={
                    showSelectedFilterOptionValues
                  }
                  showSelectedFilterOptionNature={
                    showSelectedFilterOptionNature
                  }
                  setShowSelectedFilterOptionNature={
                    setShowSelectedFilterOptionNature
                  }
                  setShowSelectedFilterOptionValues={
                    setShowSelectedFilterOptionValues
                  }
                  index={index}
                />
              ))}
            </ul>
          )}
        </section>
        <Board
          filters={selectedFilterOptions}
          tasksData={tasksData}
          setSlackShareData={setSlackShareData}
        />
      </div>
      <Task
        fetchTasksData={fetchTasksData}
        assignees={assignees}
        priorities={priority}
        tags={tags}
      />
      <AddTask assignees={assignees} priorities={priority} tags={tags} />
      {slackShareData && (
        <SlackPopup
          slackData={channelsAndUsers}
          data={slackShareData}
          setData={setSlackShareData}
        />
      )}
    </div>
  )
}

export default Tasks
